export default "__VITE_ASSET__BDhIv9Wn__"